// src/pages/Login.js
import { useState } from "react";
import { useAuth } from "../context/AuthContext";
import { Input, Btn, Spinner, Alert } from "../components/UI";

export default function Login() {
  const { login } = useAuth();
  const [email, setEmail]     = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError]     = useState("");

  const submit = async () => {
    if (!email || !password) { setError("Please enter email and password."); return; }
    setError(""); setLoading(true);
    try {
      await login(email, password);
      // AuthContext will update and App.js will redirect automatically
    } catch (e) {
      const msg = {
        "auth/user-not-found":  "No account found with this email.",
        "auth/wrong-password":  "Incorrect password.",
        "auth/invalid-email":   "Invalid email address.",
        "auth/too-many-requests": "Too many failed attempts. Please try again later.",
        "auth/invalid-credential": "Invalid email or password.",
      }[e.code] || "Sign in failed. Please check your credentials.";
      setError(msg);
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: "100vh", display: "flex", overflow: "hidden" }}>
      {/* ── Left brand panel ── */}
      <div style={{
        width: "44%", background: "var(--slate)", display: "flex", flexDirection: "column",
        justifyContent: "center", padding: "64px 56px", position: "relative", overflow: "hidden"
      }}>
        {/* Decorative circles */}
        <div style={{ position: "absolute", top: -100, right: -100, width: 360, height: 360, borderRadius: "50%", background: "rgba(255,255,255,.035)" }} />
        <div style={{ position: "absolute", bottom: -80, left: -60, width: 280, height: 280, borderRadius: "50%", background: "rgba(184,76,39,.12)" }} />
        <div style={{ position: "absolute", top: "50%", right: 40, width: 4, height: 120, background: "var(--rust)", borderRadius: 2, transform: "translateY(-50%)" }} />

        <div style={{ position: "relative", zIndex: 1 }}>
          <div style={{ fontSize: 10, fontWeight: 800, letterSpacing: 4, color: "var(--rust-light)", textTransform: "uppercase", marginBottom: 18 }}>
            Radhakrishna Academy · Ballia
          </div>
          <h1 style={{ fontSize: 44, color: "#fff", lineHeight: 1.12, marginBottom: 22, fontFamily: "'Syne', sans-serif" }}>
            Employee<br />Management<br />Portal
          </h1>
          <p style={{ color: "rgba(255,255,255,.5)", fontSize: 15, lineHeight: 1.75, maxWidth: 300 }}>
            Secure, role-based access to staff records, documents, and daily attendance.
          </p>

          <div style={{ marginTop: 52, display: "flex", flexDirection: "column", gap: 14 }}>
            {[
              { icon: "🔐", text: "Role-based access control" },
              { icon: "📋", text: "Employee records & documents" },
              { icon: "📅", text: "Daily attendance tracking" },
              { icon: "☁️",  text: "Powered by Firebase" },
            ].map(({ icon, text }) => (
              <div key={text} style={{ display: "flex", alignItems: "center", gap: 12 }}>
                <span style={{ fontSize: 16 }}>{icon}</span>
                <span style={{ color: "rgba(255,255,255,.65)", fontSize: 14 }}>{text}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* ── Right form panel ── */}
      <div style={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center", padding: 48, background: "var(--paper)" }}>
        <div style={{ width: "100%", maxWidth: 380, animation: "fadeUp .4s ease" }}>
          <div style={{ marginBottom: 40 }}>
            <div style={{ width: 48, height: 48, background: "var(--rust)", borderRadius: 12, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 22, marginBottom: 20 }}>🏫</div>
            <h2 style={{ fontSize: 28, fontFamily: "'Syne',sans-serif", marginBottom: 6 }}>Welcome back</h2>
            <p style={{ color: "var(--slate-light)", fontSize: 14 }}>Sign in to access the admin portal</p>
          </div>

          <div style={{ display: "flex", flexDirection: "column", gap: 18 }}>
            <Input
              label="Email Address"
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              placeholder="you@rka.edu"
              onKeyDown={e => e.key === "Enter" && submit()}
            />
            <Input
              label="Password"
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              placeholder="Your password"
              onKeyDown={e => e.key === "Enter" && submit()}
            />

            {error && <Alert type="error">{error}</Alert>}

            <Btn onClick={submit} disabled={loading} size="lg" style={{ width: "100%", justifyContent: "center", marginTop: 4 }}>
              {loading ? <><Spinner size={16} color="#fff" /> Signing in…</> : "Sign In →"}
            </Btn>
          </div>

          <p style={{ marginTop: 32, fontSize: 12, color: "var(--slate-light)", textAlign: "center", lineHeight: 1.6 }}>
            Access is restricted to authorised staff only.<br />
            Contact your administrator if you need an account.
          </p>
        </div>
      </div>
    </div>
  );
}
